import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import { Col, Container, Row } from "react-bootstrap";
import { useMediaQuery } from "../../../helpers/useMediaQuery";
import ReactImg from "../../../assets/images/backGrounds/react.svg";
import SemiColumn from "../../../assets/images/backGrounds/semicolumn.svg";
import Tag from "../../../assets/images/backGrounds/tag.svg";
import { t } from "i18next";
import { getBestGalleryImage } from "../../../services/gallery.service";
import Loader from "../../common/loader/Loader";
import { useSelector } from "react-redux";
import { Fade } from "react-reveal";
import RubberBand from "react-reveal/RubberBand";
import Spin from "react-reveal/Spin";
import { Link } from "react-router-dom";

const ImagesGallery = () => {
  const isTablet = useMediaQuery("(max-width: 1080px)");

  // language data from store
  const Resource = useSelector((state) => state.translation.resource);

  // get data from api
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();

  const getData = async () => {
    setIsLoading(true);
    const responseBody = {
      enablePagination: false,
    };
    const response = await getBestGalleryImage(responseBody);
    if (response?.status === 200) {
      setData(response?.data?.data?.list);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Styles>
      {isLoading ? (
        <Loader height={"100%"} />
      ) : (
        data?.length > 0 && (
          <section id="imagesGallerySection">
            <Spin>
              <img src={ReactImg} className="react-img" alt="react-img" />
            </Spin>
            <Container>
              <RubberBand>
                <img className="tag1" src={Tag} alt="tag" />
              </RubberBand>
              <RubberBand>
                <img className="tag2" src={Tag} alt="tag" />
              </RubberBand>
              <img className="semi-column" src={SemiColumn} alt="semi column" />

              <Row className="align-items-center justify-content-center main-gallery-container">
                <Col lg={5}>
                  {isTablet && (
                    <Fade bottom>
                      <div className="section-info">
                        <Link to="/gallery" className="title">
                          {Resource?.gallery_title
                            ? Resource?.gallery_title
                            : t("home.gallery.title")}
                        </Link>
                        <Link to="/gallery" className="description">
                          {Resource?.gallery_description
                            ? Resource?.gallery_description
                            : t("home.gallery.description")}
                        </Link>
                      </div>
                    </Fade>
                  )}
                  <div className="main-img">
                    {data ? (
                      <img
                        src={data[0]?.fullUrl}
                        loading="lazy"
                        alt={data[0]?.displayName}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </Col>
                <Col lg={5}>
                  <div className="section-data">
                    {!isTablet && (
                      <Fade bottom>
                        <div className="section-info">
                          <Link to="/gallery" className="title">
                            {Resource?.gallery_title
                              ? Resource?.gallery_title
                              : t("home.gallery.title")}
                          </Link>
                          <Link to="/gallery" className="description">
                            {Resource?.gallery_description
                              ? Resource?.gallery_description
                              : t("home.gallery.description")}
                          </Link>
                        </div>
                      </Fade>
                    )}
                    <Row>
                      {data?.map((item, idx) => {
                        if (idx !== 0 && idx < 5) {
                          return (
                            <Col
                              key={idx}
                              lg={6}
                              md={12}
                              className="mb-3 costomize-col"
                            >
                              <div className="img-container">
                                <img
                                  src={item?.fullUrl}
                                  loading="lazy"
                                  alt={item?.displayName}
                                />
                              </div>
                            </Col>
                          );
                        }
                      })}
                    </Row>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        )
      )}
    </Styles>
  );
};

export default ImagesGallery;
